import { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../axios';
import { Menu, Paper, Button,Text } from '@mantine/core';
import { saveAs } from 'file-saver'; // Import file-saver
import * as XLSX from 'xlsx'; // Import xlsx
import AuthContext from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
const Example = ({ updateProductModalSetting, handlePageUpdate }) => {
  const { centre, userType } = useContext(AuthContext);
  const [paid,setPaid]=useState('')
  const [balance,setBalance]=useState('')
  const[expense,setExpense]=useState('')
const  navigate=useNavigate()
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatCurrency = (value) => {
    if (isNaN(value)) return value; // In case value is not a number, return it as-is
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    }).format(value);
  };
  
  const columns = useMemo(() => {
    const cols = [
      {
        accessorKey: 'index',
        header: '#',
        size: 50,
        Cell: ({ row }) => row.index + 1,
        visible: true,
      },
      {
        accessorKey: 'full_name',
        header: 'Name',
        size: 100,
        visible:true,
      },
      {
        accessorKey: 'added_leaves',
        header: 'Total Leaves',
        size: 150,
       
        visible: true,
      },
      {
        accessorKey: 'sum_taken_leaves',
        header: 'Taken Leaves',
        size: 150,
        // Already formatted as number
        visible: true,
      },
      {
        accessorKey: 'balance_leaves',
        header: 'Pending Leaves',
        size: 150,
         // Already formatted as number
        visible: true,
      },
    ];
    return cols;
  }, [userType]);
  

  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(columns);

  useEffect(() => {
    axios.post('/employee/getall', {
      centre_id: centre,
    })
      .then((res) => {
        setData(res.data);
        

      })
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, [handlePageUpdate, centre]);

  useEffect(() => {
    try {
      rowVirtualizerInstanceRef.current?.scrollToIndex(0);
    } catch (e) {
      console.log(e);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns: visibleColumns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <>
        <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Add Leaves</Menu.Item>
        <Menu.Item onClick={() => navigate(
          `/employee/details`,{
            state: {full_name:row.original.full_name},
          },
          { replace: true }
        )}>Details</Menu.Item>
      </>
    ),
    onColumnVisibilityChange: (visible) => {
      setVisibleColumns(columns.map(col => ({
        ...col,
        visible: visible[col.accessorKey] !== false
      })));
    },
  });

  return (
    <Paper shadow="sm" p="lg" withBorder>

      <div style={{maxHeight: '500px', width: '100%' }}>
{/* Display the total paid amount */}
      <MantineReactTable
        table={table}
        striped // Enables the striped rows
        highlightOnHover
        horizontalSpacing="md"
        verticalSpacing="sm"
        fontSize="sm"
        withColumnBorders
        borderRadius="md"
        withGlobalFilter
        loading={isLoading}
        enableRowSelection={true} // Enables row selection
        enableColumnSelection={true} // Enables column selection
        height={400}
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
        enablePagination={true} // Enables pagination
      />
      </div>
    </Paper>
  );
}

export default Example;
